type PagingIntervals = [number, number][];

export const getPagingIntervals = (
  rowsPerPage: number | null,
  totalRowCount: number
) => {
  if (rowsPerPage === null) return [];

  const totalPages = Math.ceil(totalRowCount / rowsPerPage);

  return [...Array(totalPages).keys()].map((index) => {
    const from = index * rowsPerPage + 1;

    // last item
    if (index === totalPages - 1) {
      return [from, totalRowCount];
    }

    return [from, (index + 1) * rowsPerPage];
  });
};
